import React, { useEffect } from 'react';
import ProjectItem from '@gp/components/ProjectItem';
import TriggerFoldBtn from '@gp/components/TriggerFoldBtn';
import InfoBubble from '@gp/components/InfoBubble';
import CommonValueTd from '../components/CommonValueTd';
// import PercentProgress from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Finance/components/Overview/components/PercentProgress';
import { TableListColumnsItemType } from '../index.d';

/**
 * 获取表格配置项
 */
const getColumns = (
  className: string,
  tableIsScroll: boolean,
  sortColumns: string[] | undefined,
  columsOptions: TableListColumnsItemType[] | undefined,
  unFoldList: string[],
  setUnFoldList: React.Dispatch<React.SetStateAction<string[]>>,
  triggerFoldExpand: boolean,
) => {
  if (!Array.isArray(columsOptions)) return [];

  return columsOptions?.map((t: TableListColumnsItemType, i: number) => {
    const isLastCol = i === columsOptions?.length - 1;
    const {
      keyName = '',
      title, // <time>表示这个槽位取后端对应字段time数据，\n表示换行展示
      isTips = false,
      renderTips = null, // 渲染提示内容
      isHasDoubleTitle = false, // 是否有两行title的情况
      width, // 列宽
      align = 'left',
      fixed,
      isGroupCol = false, // 是否是折叠相关列，包括其父列
      isGroup = false, // 是否拥有子分类
      isLastGroup = false, // 是否是最后一个拥有子分类且折叠时在最后一列的列，用于处理折叠时最后一列的折叠按钮右边要隐藏
      groupKey, // 汇总、归总的key名
      tdOpt, // td渲染相关的配置
      contentText,
    } = t || {};
    const headers: [string, string] = title.split('\n') as [string, string];
    const headerFirTxt = isHasDoubleTitle ? headers?.[0] : title;
    const headerSecTxt = isHasDoubleTitle ? headers?.[1] : '';

    const orgWidth =
      !isGroupCol ||
      unFoldList?.includes(groupKey || '') ||
      isGroup ||
      triggerFoldExpand
        ? tableIsScroll && isLastCol && width
          ? width + 9 // 出现纵向滚动条时最后一列宽度追加上滚动条的宽度
          : width
        : 0;
    // 当前项是否展开
    const isExpand = unFoldList?.includes(keyName);
    // 是否因为纵向滚动条影响折叠按钮的位置
    const flag = tableIsScroll && !isExpand && isLastGroup;

    return {
      key: keyName,
      header: (
        <div className="dbg-table-header-text">
          <InfoBubble
            className="globalpedia-modal-font14 gp-general-table-bubble-line-height dbg-bubble-max-width"
            placement={isLastCol ? 'top-end' : undefined}
            customBubbleContent={isTips ? renderTips?.(keyName) : undefined}
            DomOrText={
              <>
                {headerFirTxt}
                {isHasDoubleTitle && (
                  <>
                    <br />
                    {headerSecTxt}
                  </>
                )}
              </>
            }
          />
          {!!isGroup && (
            <section
              className="header-fold-btn"
              style={{
                // 最后一个折叠项没有展开时要隐藏展开按钮的右边
                zIndex: isLastGroup && !isExpand ? 0 : 10,
                // 折叠按钮横向位置的判断处理
                right: (sortColumns || [])?.includes(keyName)
                  ? flag
                    ? -47
                    : -56
                  : flag
                  ? -37
                  : -46,
              }}
              onClick={(e: any) => {
                e.stopPropagation();
              }}
            >
              {/* <TriggerFoldBtn
                foldBubble="Expand"
                state={unFoldList?.includes(keyName)}
                contentText={contentText ? contentText : ''}
                onClick={() => {
                  // 判断展开列表中是否存在，存在的话，删除展开列表中的key，不存在的话，把key加到展开项中
                  const index = unFoldList?.findIndex(
                    (item: string) => item === keyName,
                  );
                  const newUnFoldList =
                    index >= 0
                      ? unFoldList?.filter((item: string) => item !== keyName)
                      : [...unFoldList, keyName];
                  setUnFoldList(newUnFoldList);
                  // 展开最后一项时，往右滚动到最右边，让用户知道后面还有展开的列，增强用户体验
                  if (index === -1 && isLastGroup) {
                    const t = setTimeout(() => {
                      const tableBodyEl: any = document.querySelector(
                        `.${className} .tea-table__body`,
                      );
                      if (tableBodyEl) {
                        const currentWidth = tableBodyEl.offsetWidth,
                          scrollLeft = tableBodyEl.scrollLeft,
                          scrollWidth = tableBodyEl.scrollWidth;
                        // 出现滚动条时，此时自动向右滚动到最右边
                        if (scrollWidth - currentWidth > 0) {
                          tableBodyEl.scrollLeft = scrollWidth - currentWidth;
                        }
                      }
                      clearTimeout(t);
                    }, 200);
                  }
                }}
              /> */}
            </section>
          )}
        </div>
      ),
      align,
      fixed,
      width: orgWidth,
      render: (cvm: any) => {
        const typeKey =
          Object.prototype.toString.call(tdOpt) === '[object Object]'
            ? Object?.keys(tdOpt as object)?.[0] || ''
            : '';
        let con: JSX.Element | string = '-';

        switch (typeKey) {
          case 'text':
            con = cvm?.[tdOpt?.[typeKey]?.text || ''] || '-';
            break;

          case 'number':
            con = (
              <CommonValueTd
                tdAlign={align}
                options={tdOpt?.[typeKey]?.options}
                data={cvm}
              />
            );
            break;

          case 'project':
            const {
              domain,
              src = '', // 取值的字段名
              title = '', // 取值的字段名
              platform = '', // 取值的字段名
              platformPlaceHolder,
              platformTranformSolt = false, // 把platform转换成solt显示
              renderSolt = null, // 渲染solt插槽
              toDetails = null,
              isVisibleFixedCustomBubble = false, // 是否展示固定格式气泡内容
              bubbleClassName,
              bubbleStyle,
              renderCustomBubbleContent = null, // 渲染固定格式气泡内容
            } = tdOpt?.[typeKey] || {};
            const toDetailsNew = domain === 'studio' && cvm?.studio_id === 'All Studios' ? null : toDetails;
            con = (
              <ProjectItem
                domain={domain}
                src={cvm?.[src || '']}
                title={cvm?.[title || '']}
                platform={cvm?.[platform || '']}
                platformPlaceHolder={platformPlaceHolder}
                platformTranformSolt={platformTranformSolt}
                solt={renderSolt?.(cvm)}
                data={cvm}
                toDetails={toDetailsNew}
                isVisibleFixedCustomBubble={isVisibleFixedCustomBubble}
                bubbleClassName={bubbleClassName}
                bubbleStyle={bubbleStyle}
                customBubbleContent={renderCustomBubbleContent?.(cvm)}
              />
            );
            break;

          case 'customize':
            const { render = null } = tdOpt?.[typeKey] || {};
            con = render?.(cvm) || '-';
            break;

          default:
            con = cvm?.[tdOpt?.['text']?.text || ''] || '-';
            break;
        }

        return orgWidth ? con : null;
      },
    };
  });
};

export { getColumns };
